

























































import { Component, Vue, Prop } from "vue-property-decorator";
import VcNavArrow from "@/components/form_components/VcNavArrow.vue";
import { storePasien } from "@/store/modules/pasien";
import MasterReferensi from "@/store/modules/new/MasterReferensi";

@Component({
  components: { VcNavArrow }
})
export default class VCDateTimePicker extends Vue {
  @Prop({ required: true, default: null })
  readonly value!: string | Date;
  @Prop({ required: false, default: null }) label: string;
  @Prop({ required: false, default: null }) hint: string;
  @Prop({ required: false, default: null }) prependIcon: string;
  @Prop({ required: false, default: null }) appendIcon: string;
  @Prop({ required: false, default: null }) appendOuterIcon: string;
  @Prop({ required: false, default: () => [] }) rules: any[];
  @Prop({ required: false, default: null }) max: string | Date;
  @Prop({ required: false, default: null }) min: string | Date;
  @Prop({ required: false, default: 1 }) firstDayOfWeek: number;
  /** "dateTime" (bawaan) atau "date" untuk isian tanpa jam. */
  @Prop({ required: false, default: "dateTime" }) mode: string;
  @Prop({ type: Boolean, required: false, default: false })
  showHolidays!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  disabled!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  readonly!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  positionFixed!: boolean;

  todayDate = new Date();
  inputfieldLoading = false;
  inputfieldHint = "";

  selectedDate = null;

  get popoverConfig() {
    return { visibility: "click", positionFixed: this.positionFixed };
  }

  get date(): string | Date {
    return this.value;
  }
  set date(val) {
    this.$emit("input", val);
  }

  get minDate(): Date {
    if (typeof this.min === "string") {
      return new Date(this.min);
    }
    return this.min;
  }

  get maxDate(): Date {
    if (typeof this.max === "string") {
      return new Date(this.max);
    }
    return this.max;
  }

  get disabledDate() {
    const holiday = this.showHolidays
      ? this.holidays.map(it => new Date(it.date))
      : [];

    return [...holiday];
  }

  get datePickerAttributes() {
    const holiday = this.showHolidays
      ? this.holidays.map(it => {
          return {
            highlight: {
              contentStyle: {
                color: "red",
                "font-weight": "bold"
              }
            },
            dates: new Date(it.date),
            popover: {
              label: it.note
            }
          };
        })
      : [];

    return [...holiday];
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get holidays() {
    return MasterReferensi.holidays;
  }

  onInput(val) {
    this.$emit("input", val);
  }
}
